module.exports = __webpack_public_path__ + "media/images/stickers/sticker1-2e2793a1e5d95c0107c65bee32b89f1c.svg";